import React from 'react'
// import LogoCard from './LogoCard'

const Footer = () => {
  const d = new Date()
  return (
    <div>
  <footer className="bg-gray-900 dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700 text-white sticky bottom-0 w-full py-4 border-t-2 border-white text-center">
    <div className="sm:container mx-auto px-4">
      <div className="flex flex-col md:flex-row justify-center items-center">
        {/* About Section */}
        <div className="mb-4 md:mb-0">
          <p className="text-base mt-1 font-serif">
            {/* I'm a passionate web developer with expertise in creating dynamic and user-friendly websites. Let's build something great together! */}
          </p>
        </div>
        
        <div className="text-center border-2 border-dashed p-2">
          <p className='font-sans'>© {d.getFullYear()} <span className='font-serif'> MH DEV All Rights Reserved. </span></p>
        </div>
      </div>
    </div>
  </footer>
</div>

  )
}

export default Footer
